import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {FcPlus} from "react-icons/fc" 
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Button, Grid, Typography } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';



const UpdateAddItemDetails = (props) => {





  let len = props.addMore.length-1;
  let descriptiv = "descriptive-"+len
  var str;
  var number=document.getElementById("verticle_type")
  if (number != null) {
    str = number.value;
  }

  let dstin = props.addMore[len].distin;
  // console.log(props);


    {/*-------------------------- get sub catogeory value ----------------------------------------*/}

    const [subCategory, setsubCategory] = useState([]);
    function handleCategory(event) {
      let categoryName = event.target.value;
      // console.log(event.target.id);
      axios.get(`api/subcatgory_details/${categoryName}`).then(res => {
        if (res.status === 200) {
          setsubCategory({...subCategory,[event.target.id]:res.data.subCatgoryDetails});
        }
      });

    }


    
 
    const [notest, setnotest] = useState();
    const [lastValue, setlastValue] = useState(0);
      function testChange(e){
        // console.log("testchange is called")
       // var testNo=document.getElementById(test).value
       var verticletype=document.getElementById("vertical_name").value;
      //  console.log(verticletype);
       var date=document.getElementById("date").value;
      //  console.log(date);
       var series=document.getElementById("serial_type").value;
       // console.log('kfk',testNo)
       if(len==1){
         var testNo=document.getElementById(test).value
         var testNos = testNo;
         // setlastValue(testNos)
       }else{
         var testNos = 1;
         // setlastValue(testNos)
       }
       // console.log(e.target.value);
   
       var name = e.target.name;
       var finalNoValue = '';
       if(name==='test'){
         var swlvalue = e.target.value;
         if(verticletype){
           var lastNo = '';
           if(len==0){
             axios.get(`api/last_nos/${verticletype}/${date}/${series}`).then(res => {
               var lastNo = res.data.lastNos;
             // console.log('lastNos',lastNo);
               var swvalue = Number(lastNo)+Number(swlvalue)-1;
               setlastValue(swvalue+1)
               var finalNoValue = lastNo +' to '+swvalue;
               setnotest(finalNoValue)
             });
           }else{
             var swvalue = Number(lastValue)+Number(swlvalue)-1;
             var finalNoValue = lastValue+' to '+ swvalue;
             setlastValue(swvalue+1)
             setnotest(finalNoValue)
           }
         }
       }
       setnotest(finalNoValue)
      }

       // swl and nos no continate and populate disy=ting value
  const [finalvalue, setfinalvalue] = useState([]);
  const [finaldistinc, setfinaldistinc] = useState();
  function swlChange(e) {
    var name = e.target.name;
    var finalSwlValue = "";
    var party_code = document.getElementById("party_code").value;
    var date = document.getElementById("date").value;
    var dateArray = date.split("-");
    var distinct = "";
    if (party_code) {
      if (date) {
        var distinct = party_code + "/ " + dateArray[1] + "/ ";
      } else {
        var distinct = party_code + "/ ";
      }
    }

    // if (name === "swltonns") {
      // var swlvalue = e.target.value;
      var swlvalue = document.getElementById("swltonns-"+len).value;
      
      var finalSwlValue = "\n SWL " + swlvalue;
    // }
    // setfinaldistinc(finalSwlValue)
    var finalTaxt = distinct + notest + finalSwlValue;
    // console.log(finaldistinc)

    setfinalvalue({ ...finalvalue, [dstin]: finalTaxt });
  }

  function swlChange2(e) {
    var name = e.target.name;
    var finalSwlValue = "";
    var party_code = document.getElementById("party_code").value;
    var date = document.getElementById("date").value;
    var dateArray = date.split("-");
    var distinct = "";
    if (party_code) {
      if (date) {
        var distinct = party_code + "/ " + dateArray[1] + "/ ";
      } else {
        var distinct = party_code + "/ ";
      }
    }

    // if (name === "swltonns") {
      // var swlvalue = e.target.value;
      var swlvalue = document.getElementById("swltonns2"+len).value;
      
      var finalSwlValue = "\n SWL " + swlvalue;
    // }
    // setfinaldistinc(finalSwlValue)
    var finalTaxt = distinct + notest + finalSwlValue;
    // console.log(finaldistinc)

    setfinalvalue({ ...finalvalue, [dstin]: finalTaxt });
  }
        // console.log("hELLO");
        // console.log(finalvalue);
  {/*-------------------------- get Item Name ----------------------------------------*/}
    const [items, setItem] = useState([]);
    function handleItem(event) {
      let sunCategoryName = event.target.value;
      axios.get(`api/item_details/${sunCategoryName}`).then(res => {
        if (res.status === 200) {
          setItem({...items,[event.target.id]:res.data.itemDetails});
        }
      });

    }


    {/*-------------------------- get Desiption value ----------------------------------------*/}
    let [description, setDescription] = useState();
    function handleDes(event) {
      let item = event.target.value;
      axios.get(`api/description/${item}`).then(res => {
        if (res.status === 200) {
          let des = res.data.desctiption;
          // setDescription({...description,[descriptiv]:des})

          document.getElementById(descriptiv).value=des;
        }
      });

    }

    // console.log(descriptiv);


  {/*-------------------------- get Desiption length ----------------------------------------*/}


 const [lineCount, setlineCount] = useState([]);
    function descriptionLineCount(event) {
      let item = event.target.value;
      const descriptiveId = event.target.id
      // console.log('getID',event.target.name+event.target.id);
      // console.log('value',descriptiveId)

      // let length = event.target.value.length;
      // if(length>70){
      //   var lineCheck = Math.floor(length/60)
      //   // console.log('Length',lineCheck)
      // }else{
      //   var lineCheck = 0;
      // }
      let count = 1; //+lineCheck;
      for (let i = count; i < event.target.value.length; i++) {
        if (event.target.value[i] == '\n') {
          count++
        }
      }
      // let totalLineCount = lineCount + count;
      // console.log('Previous count',count);
      // setlineCount(count);
      setlineCount({...lineCount,[descriptiveId]:count});


    }

  // remove line count 
  function removecount(val,deletebutton){
      props.delete(val);
      setlineCount(current => {
        const copy = {...current};
        delete copy[deletebutton];
        return copy;
          // remove cost key from object
          // const {cost, ...rest} = current;
          // return rest;
          // console.log(current)
        });
      // console.log('Delete index',Math.round(val.index))
    }


{/*-------------------------- get catogeory value ----------------------------------------*/}
  const [categorylist, setCategorylist] = useState([]);
   useEffect(() => {

      axios.get(`api/show_categorydetails`).then(res => {
        if (res.status === 200) {
          // console.log(res.data.categorydetails);
          setCategorylist(res.data.categorydetails);

          //set description line 
          let getDes = document.getElementById(descriptiv).value.length;
          let dom = document.getElementById(descriptiv).value;
            if(getDes>0){
              var count = 1;//Math.floor(getDes/40)
              // console.log('Length',lineCheck)
              for (let i = count; i < getDes; i++) {
                if (dom[i] == '\n') {
                  count++
                }
              }
            }
          setlineCount({...lineCount,[descriptiv]:count});

          // console.log(count);
        }
      });
    }, []);


   const values =
    categorylist.map((item) => {
      return (
        <option value={categorylist.categoryname}>{item.categoryname}</option>
      )
    });
    // document.getElementById(descriptiv).call=countNum();

    // function countNum(){
    //   console.log('hdhd')
    // }

{/*---------------------line count logics ----------------*/}
  var count= Object.keys(lineCount).length;

  var checklineCount = 0;


  for (let index = 0; index < count; index++) {
    if(len>=index){  
      let indexche = "descriptive-"+index 
      // console.log('Index',indexche)
      // console.log('hdhd',indexche)
      if(indexche in lineCount){
        checklineCount += lineCount[indexche];
        // console.log('checklineCount',checklineCount)
      }
    }
  }
  // const [totalLine, settotalLine] = useState([checklineCount]);

  // console.log('Total count',checklineCount)


// props.delete()



{/*-------------------------- Submit and add more button disabled after line count 16 -----------------------------------*/}
  if(checklineCount>16){
    alert("use max 16 lines ")
    // hide("#button")
    document.getElementById("update").disabled = true;
    // document.getElementById("plusButton").disabled = true;
    // ("#button").remove();
  }
  else if(checklineCount<12){
    // document.getElementById("submit").disabled = false;
    const button = document.getElementById('update');
    // console.log(button);
       // const buttonPlus = document.getElementById('plusButton').disabled=true;
    if (button != null) {
      button.disabled = false;
    }
  }


  // console.log('current count',buttonPlus);
  

  return (
    props.addMore.map((val, idx) => {
      let distin = `distin-${idx}`, sn = `sn-${idx}`, descriptive = `descriptive-${idx}`, test = `test-${idx}` ,
       pltonns = `pltonns-${idx}` , swltonns = `swltonns-${idx}`, swltonns2 = `swltonns2-${idx}`,categoryname = `categoryname${idx}`,item = `item${idx}`
       ,subcategory = `subcategory${idx}`, deletebutton = `descriptive-${idx}`;

       // console.log(val);
       var ali = val.distin;
       const splitString = val.test.split(" ");
     
       

      return (
        <tr key={val.index}>
          <td>
              <select name="categoryname" data-id={idx} id={categoryname} onChange={handleCategory} className="form-control" >
                  <option value="">-Select Category-</option>
                  {values}

              </select>                     
          
              <select name="subcategory" data-id={idx} id={subcategory}    onChange={handleItem} values={subCategory} className="form-control" >
                  <option value="">-Sub Category-</option>
                  { subCategory[categoryname]!=undefined? subCategory[categoryname].map((item) => {
                      return (
                        <option value={subCategory.subcategoryname}>{item.subcategoryname}</option>
                      )
                      }): console.log()
                  }
              </select>                     
         
              <select name="item" data-id={idx} id={item}  onChange={handleDes} className="form-control" >
                  <option value="">-Item Name-</option>
                  { items[subcategory]!=undefined? items[subcategory].map((item) => {
                      return (
                        <option value={items.item}>{item.itemname}</option>
                      )
                      }): console.log()
                  }
              </select>                     
          </td>
          <td>
            <textarea name="distin" defaultValue={val.distin} rows="4" data-id={idx} id={distin} className="form-control"></textarea>
          </td>
          {/*<td>
            <input type="text"  style={{paddingTop: "30px",paddingBottom: "30px",marginTop:"12px"}} height="100" name="sn" id={sn} data-id={idx} className="form-control " />
          </td>*/}
        
          <td>
            <textarea name="descriptive"  defaultValue={val.descriptive} cols='5' onChange={descriptionLineCount} id={descriptive} data-id={idx} className="form-control" rows="8"></textarea>
          </td>
          <td>
            <input type="text" onChange={testChange} defaultValue={splitString[0]} style={{paddingTop: "30px",paddingBottom: "30px",marginTop:"12px"}} name="test" id={test} data-id={idx} className="form-control " />
            <textarea type="nostest_remarks" defaultValue={splitString[1]} style={{paddingTop: "30px",paddingBottom: "30px",marginTop:"12px"}} name="nostest_remarks" data-id={idx} className="form-control " />
          </td>
          <td>
            <input type="text"  defaultValue={val.pltonns} style={{paddingTop: "30px",paddingBottom: "30px",marginTop:"12px"}} name="pltonns" id={pltonns} data-id={idx} className="form-control " />
          </td>
          <td>
            <textarea type="text" onChange={swlChange} defaultValue={val.swltonns} style={{paddingTop: "30px",paddingBottom: "30px",marginTop:"12px"}} name="swltonns" id={swltonns} data-id={idx} className="form-control " />
            <textarea type="swl_remarks"  rows="2" style={{marginTop:"12px"}} defaultValue={val.swltonns2} name="swltonns2" data-id={idx} id={swltonns2} className="form-control " />
          </td>
          <td>
        <input class="form-check-input" style={{ marginTop: "14px",marginLeft:"15px" }} onClick={swlChange} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
        {/* <label class="form-check-label" for="flexRadioDefault1">
          Default radio
        </label> */}
        <input class="form-check-input" onClick={swlChange2} style={{ marginTop: "100px",marginLeft:"15px" }} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
        {/* <label class="form-check-label" for="flexRadioDefault1">
          Default radio
        </label> */}
        </td>
            <td >
              {
              idx===0?
              
                checklineCount<13?
                  <Button title="Add More" style={{color:"white",marginTop:"30px",minWidth:"0px",padding:"0px"}} onClick={()=>props.add()} type="button" ><FcPlus/></Button>
                :console.log()
              : <Button id={deletebutton} startIcon={<DeleteIcon color='inherit' />} style={{color: "#cc0000",marginTop:"30px",minWidth:"0px",padding:"0px"}} onClick={(() => removecount(val,deletebutton))} ></Button>
              }
            </td>
        </tr >
      )
    })
  )
}
export default UpdateAddItemDetails